<template>
  <div class="basic-page">
    <!-- <div class="information-logo">
      <div class="title">这里是SLOGAN这里是SLOGAN这里</div>
      <div class="text">这里是SLOGAN这里是SLOGAN这里</div>
    </div> -->
    <TopTitle title="基本信息" />

    <div v-if="!updatePhoneType && !updateEmailType">
      <div class="line-div">头像昵称</div>
      <div style="height: 140px;">
        <div class="flex top-div">
          <div class="pic-div" @click="updateImg">
            <img v-if="(userData && userData.avatar)" :src="userData.avatar" alt="" width="76px" height="76px" />
            <img v-else :src="imgs.userImg" alt="" width="76px" height="76px" />

            <div class="content-center update-div">修改</div>
          </div>
          <div class="info">
            <div class="flex">
              <div class="title-small" style="margin: 0 180px 24px 32px;">昵称</div>
              <div class="text-content" v-if="!nameType">{{ (userData && userData.nickname) ? userData.nickname : '-'}}</div>
              <div v-else>
                <div style="margin-bottom: 16px;">
                  <el-input class="input-name" v-model="userName" placeholder="请输入昵称" />
                </div>
                <div>
                  <el-button @click="overUpdate(false)" class="input-btn">取消</el-button>
                  <el-button @click="overUpdate(true)" class="input-btn" type="primary">保存</el-button>
                </div>
              </div>

              <div class="approve" @click="updateName" v-if="!nameType">
                <el-link type="primary" :underline="false">编辑</el-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="line-div">个人信息</div>
      <div>
        <div class="flex top-div">
          <div class="info">
            <div class="flex">
              <div class="title-small">手机号码</div>
              <div class="text-content">{{ (userData && userData.phone) ? userData.phone : '-'}}</div>
              <div class="approve" v-if="(userData && userData.phone)" @click="updatePhoneType = true">
                <el-link type="primary" :underline="false">修改</el-link>
              </div>
            </div>
            <div class="flex">
              <div class="title-small">邮箱</div>
              <div class="text-content">{{ (userData && userData.email) ? userData.email : '-'}}</div>
              <div class="approve" @click="updateEmailType = true">
                <el-link type="primary" :underline="false">修改</el-link>
              </div>
            </div>
            <div class="flex">
              <div class="title-small content-center">所在企业
                <el-popover trigger="hover" placement="top">
                  <div class="text-content">企业暂不支持退出，若有需要请联系客服</div>
                  <div slot="reference" class="name-wrapper content-center">
                    <img :src="imgs.question" width="12px" height="12px" style="margin-left: 8px;" />
                  </div>
                </el-popover>
                <!-- <el-tooltip content="企业暂不支持退出，若有需要请联系客服" placement="top">
                  <i class="el-icon-question" style="margin-left: 8px;color: #62A1F2;font-size: 18px;"></i>
                </el-tooltip> -->
              </div>
              <el-popover trigger="hover" placement="top" v-if="(userData && userData.companyStatus == 20)">
                <div class="content-center">{{ (userData && userData.companyName) ? userData.companyName : '-'}}</div>
                <div slot="reference" class="name-wrapper">
                  <div class="text-content">{{ (userData && userData.companyName) ? userData.companyName : '-'}}</div>
                </div>
              </el-popover>
              <div class="text-content" v-else>-</div>

              <div class="approve" v-if="!userData.companyName" @click="goApprove">
                <el-link type="primary" :underline="false">去认证</el-link>
              </div>
              <!-- 已认证 -->
            </div>
            <!-- <div class="flex">
              <div class="title-small">密码</div>
              <div class="text-content">**********</div>
              <div class="approve">修改</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <UpdatePhone v-if="updatePhoneType" @lastStep="lastStep" :phone="(userData && userData.phone) ? userData.phone : ''" />
    <UpdateEmail v-if="updateEmailType" @lastStep="lastStep" />

    <!--修改手机号-->
    <Phone ref="phone" :visible="phoneVisible" />
    <!--修改邮箱-->
    <Email ref="email" :edit="emailEdit" :visible="emailVisible" />
    <!-- 修改用户头像 -->
    <ImageCropper ref="image" :visible="imageVisible" @uploadSuccess="getUserInfo" />
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax"
import Phone from './components/phone'
import UpdatePhone from './components/UpdatePhone'
import UpdateEmail from './components/UpdateEmail'
import Email from './components/email'
import ImageCropper from './components/ImageCropper'
import CellTitle from '@/components/CellTitle'
import TopTitle from '@/components/TopTitle'


const imgs = {
  userImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/userImg.png',
  question: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/question.png',
}


export default {
  name: "Basic",
  components: {
    Phone,
    Email,
    ImageCropper,
    CellTitle,
    TopTitle,
    UpdatePhone,
    UpdateEmail
  },
  data () {
    return {
      imgs,
      nameType: false,
      userName: '', // 用户昵称
      updatePhoneType: false, // 修改手机号
      updateEmailType: false, // 修改邮箱

      loading: false,
      userData: {
        avatar: ''
      },
      userFormData: {},
      moreDialogVisible: false,
      companyData: null,
      phoneVisible: false,
      emailVisible: false,
      emailEdit: false,
      imageVisible: false,
      enterpriseVisible: false,
      userCheck: {
        nickname: [{ required: true, message: '请输入用户昵称', trigger: "change" }],
      },
    }
  },
  mounted () {
    this.getCurrentCompany()
    this.getUserInfo()
  },
  methods: {
    // 去认证
    goApprove () {
      if (this.userData.companyName) {
        return
      }
      this.$router.push({ name: 'certification' })
    },
    // 获取用户信息
    getUserInfo () {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.userData = response.data

          this.$store.dispatch("user/setUserData", response.data).then(() => {
            localStorage.setItem('userData', JSON.stringify(response.data))
          })

        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 返回
    lastStep () {
      console.log(2)
      this.updatePhoneType = false
      this.updateEmailType = false
      this.getUserInfo()
    },
    // 修改头像
    updateImg () {
      this.imageVisible = true
    },
    //修改昵称
    updateName () {
      this.userName = this.userData.nickname
      this.nameType = true
    },
    // 修改结束
    overUpdate (type) {


      if (type) {
        if (!this.userName) {
          this.$message({
            message: '昵称不能为空',
            type: 'error'
          })
          return
        }
        httpAjax({
          url: '/services/user/update/my',
          method: 'put',
          data: {
            nickname: this.userName
          }
        }).then((response) => {
          if (response.success) {
            this.$message({
              message: '用户信息修改成功',
              type: 'success'
            })
            this.getCurrentCompany()
            this.getUserInfo()
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        })
      }
      this.userName = ''
      this.nameType = false
    },


    // 获取公司认证信息
    getCurrentCompany () {
      this.loading = true
      httpAjax({
        url: '/services/company/currentCompany',
        method: 'get',
      }).then(response => {
        this.loading = false
        if (response.success) {
          if (response.data) {
            this.companyData = response.data
          } else {
            this.companyData = response.data
            this.userData.companyStatus = 10
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 修改用户信息
    handRevise (type, val) {
      const revise = {
        'phone': () => {
          this.phoneVisible = true
          this.$refs.phone.formData.phone = val
          this.$refs.phone.codeSend = true
          val && (this.$refs.phone.Steps = 0)
        },
        'email': () => {
          this.emailEdit = !!val
          this.emailVisible = true
          if (val) {
            setTimeout(() => {
              this.$refs.email.Steps = 0
              this.$refs.email.getEditEmail(val)
            }, 50)
          }
        }
      }
      revise[type]()
    },

    cropSuccess (resData) {
      this.imageVisible = false
      this.imagecropperKey = this.imagecropperKey + 1
      this.image = resData.files.avatar
    },
    close () {
      this.imageVisible = false
    }
  }
}
</script>

<style scoped lang="less">
.basic-page {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  // /deep/ .el-popper {
  //   /deep/ .popper__arrow::after {
  //     border-top-color: #fff !important;
  //   }
  // }
  // /deep/ .popper__arrow {
  //   border-top-color: #fff !important;
  // }
  // /deep/ .popper__arrow::after {
  //   border-top-color: #fff !important;
  // }

  /deep/ .el-tooltip__popper[x-placement^="top"] .popper__arrow::after {
    border-top-color: #fff !important;
  }
  /deep/ .popper__arrow::after {
    border-top-color: #fff !important;
  }
  /deep/ .el-tooltip__popper[x-placement^="top"] .popper__arrow {
    border-top-color: #fff !important;
  }
  /deep/ .popper__arrow {
    border-top-color: #fff !important;
  }

  .top-div {
    margin: 32px 0 32px 0;
  }
  .pic-div:hover {
    .update-div {
      display: flex;
    }
  }
  .pic-div {
    border-radius: 4px;
    overflow: hidden;
    width: 76px;
    height: 76px;
    position: relative;
    cursor: pointer;
    .el-image {
      border-radius: 4px;
      height: 76px;
      width: 76px;
    }
    .update-div {
      display: none;
      width: 76px;
      height: 20px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0px 0px 4px 4px;
      position: absolute;
      bottom: 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .info {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    /deep/ .el-input__inner {
      width: 176px;
      height: 32px;
    }
    .input-btn {
      width: 80px;
      height: 32px;
      line-height: 0;
    }

    .title-small {
      margin: 0 180px 24px 108px;
      color: #666666;
      text-align: right;
      width: 86px;
    }
    .text-content {
      width: 196px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
    .approve {
      color: #1170eb;
      margin-left: 180px;
      cursor: pointer;
    }
  }

  .line-div {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #f7f7fa;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    padding-left: 16px;
  }

  /deep/ .el-empty {
    padding: 0;

    .el-empty__image {
      width: 56px;
    }
  }
  .out {
    /deep/.el-dialog__footer {
      text-align: center;
    }
    /deep/.el-dialog__body {
      padding: 0;
    }
  }

  .information-logo {
    width: 100%;
    height: 140px;
    // background: url("../../../../assets/images/bg.jpg") no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    font-weight: 400;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 4px;

    .title {
      font-size: 20px;
      padding-top: 30px;
    }

    .text {
      font-size: 12px;
      line-height: 18px;
    }
  }

  .company-user {
    margin: 20px 0;
    height: 206px;
    display: flex;
    background: white;
    border-radius: 4px;

    .card {
      width: 50%;
      box-sizing: border-box;
      margin: 24px;

      .company-content {
        display: flex;

        .company-member-logo {
          width: 94px;

          .user-logo {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;
            margin-bottom: 10px;
            position: relative;

            .user-logo-revise {
              width: 100%;
              height: 20px;
              font-size: 12px;
              color: white;
              text-align: center;
              line-height: 20px;
              position: absolute;
              bottom: 0;
              background: rgba(0, 0, 0, 0.5);
              cursor: pointer;
            }
          }

          .user-Certification {
            display: inline-block;
            font-size: 12px;
            background: #07a5eb;
            border-radius: 2px;
            color: white;
            padding: 1px 8px;
            margin: 4px 0 0 2px;
            cursor: pointer;

            .iconfont {
              font-size: 10px;
              color: #f4ea2a;
              padding-right: 2px;
            }

            .certification {
              color: white;
            }
          }
        }

        .company-member-right {
          flex: 1;

          .data {
            font-size: 14px;
            font-weight: 400;
            margin-top: 8px;

            .label {
              display: inline-block;
              width: 86px;
              color: #666666;
            }

            .text {
              display: inline-block;
              color: #222222;

              .text-l {
                padding-right: 8px;
              }

              .modify {
                color: #00a0e9;
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .ri-border {
      border-right: 1px solid #dddddd;
    }
  }

  .company-member {
    width: 100%;
    background: white;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 24px;
    margin-bottom: 20px;

    a {
      font-size: 12px;
      color: #00a0e9;
      cursor: pointer;
    }

    .company-member-horizontal-list {
      width: 100%;
      display: flex;

      .company-member-item {
        width: 110px;
        padding-top: 22px;

        .company-member-logo {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          overflow: hidden;
          background-size: 100% 100%;
          margin: 0 auto;

          .user-logo {
            width: 100%;
            height: 100%;
          }
        }

        p {
          padding: 8px 8px 0;
          font-size: 14px;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }

    .new-apply-box {
      width: 80px;
      height: 24px;
      background: #00a0e9;
      line-height: 24px;
      text-align: center;
      position: absolute;
      top: -3px;
      right: 86px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      border-radius: 4px;
      a {
        color: #ffffff !important;
      }
    }

    .new-apply-box::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-top: 7px solid transparent;
      border-left: 7px solid #00a0e9;
      border-bottom: 7px solid transparent;
      position: absolute;
      right: -5px;
      top: 5px;
    }
  }
}
</style>